module.exports = __webpack_public_path__ + "static/media/shoucang.71c1cb85.png";